export default {
  allOrganizations: [],
  organization: undefined,
  organizations: [],
};
